import React from 'react';
import AsyncSelect from 'react-select/async';
import { components }  from 'react-select';
import Spinner from '@atlaskit/spinner';

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    { props.selectProps.isLoading ? <Spinner delay={10} size={14} /> : <SearchIcon /> }
  </components.DropdownIndicator>
);

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    padding: 10,
    color: state.isFocused ? '#027BFF' : 'black',
  }),
  control: (provided, state) => ({
    // none of react-select's styles are passed to <Control />
    ...provided,
    padding: 0,
    minHeight: 15,
    maxHeight: 30,
    overflowY: 'auto',
  }),
  clearIndicator: (provided, state) => ({
    ...provided,
    padding: 0,
    color: state.isFocused ? '#027BFF' : '#DDD',
  }),
  singleValue: (provided, state) => ({
    ...provided,
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    ':hover': {
      backgroundColor: '#027BFF',
      color: 'white',
    },
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? '#027BFF' : '#DDD',
  }),
}

const ClearIcon = (props) => (<i className="fa fa-times" />)
const SearchIcon = (props) => (<i className="fa fa-search" />)
const ClearIndicator = props => {
  const {
    children = <ClearIcon />,
    getStyles,
    innerProps: { ref, ...restInnerProps },
  } = props;
  return (
    <div
      {...restInnerProps}
      ref={ref}
      style={getStyles('clearIndicator', props)}
    >
      <div style={{ padding: '0px 5px' }}>{children}</div>
    </div>
  );
};

const SearchBar = props => (
  <AsyncSelect
    styles={customStyles}
    placeholder= "XXXXX.XXX.XXXXXX"
    components={{
      ClearIndicator,
      DropdownIndicator,
      LoadingIndicator: () => null,
      IndicatorSeparator: () => null,
    }}
    openMenuOnClick={false}
    isClearable={true}
    noOptionsMessage={() => null}
    {...props}
  />
)

export default SearchBar;
